export default class AccountList {
  constructor() {
    this.isAccountListLoaded = false;
    this.accountList = [];
  }
}
